import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookOpen, faTimes } from "@fortawesome/free-solid-svg-icons";
import styles from "./EmptyState.module.css";

const EmptyState = ({ searchQuery, clearSearch }) => {
	return (
		<div className={styles.emptyState}>
			<FontAwesomeIcon icon={faBookOpen} className={styles.emptyIcon} />
			<h3 className={styles.emptyTitle}>No Lectures Found</h3>
			<p className={styles.emptyText}>
				{searchQuery
					? "No lectures match your search criteria."
					: "Start tracking your classes by logging your first lecture."}
			</p>
			{searchQuery && (
				<button className={styles.clearFiltersButton} onClick={clearSearch}>
					<FontAwesomeIcon icon={faTimes} /> Clear Search
				</button>
			)}
		</div>
	);
};

export default EmptyState;
